import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Splide from '@splidejs/splide';

export default function InitSplide() {
    productSlider();
    initContentSlider();
};

function productSlider() {
    const splides = document.querySelectorAll('.splide.product_splide');

    if (splides.length) {
        splides.forEach((splide) => {
            new Splide(splide, {
                type: 'slide',
                pagination: true,
                arrows: true,
                cover: false,
                autoWidth: true,
                perMove: 2,
                lazyLoad: 'sequential'
            }).mount();
        });
    }
}

export function getMainSplide(selector) {
    return new Splide(selector, {
        type: 'slide',
        pagination: false,
        arrows: false,
        cover: false,
        autoWidth: true,
        perMove: 1,
        lazyLoad: 'sequential'
    });
}

function getThumbnailSplide(selector) {
    return new Splide(selector, {
        rewind: true,
        autoWidth: true,
        isNavigation: true,
        gap: 0,
        focus: 'left',
        pagination: false,
        cover: false,
        arrows: false,
        dragMinThreshold: {
            mouse: 4,
            touch: 10,
        },
    });
}

function initContentSlider() {
    const parentSelector = 'section.testimonials';
    const selector = $(parentSelector + ' .splide.testimonial_slider');
    if (selector.length) {
        selector.each(function () {
            const parent = $(this).closest(parentSelector);
            const thumbnailSelector = parent.find('.content-thumbnail-splide');
            if (thumbnailSelector.length) {
                let mainSplide = getMainSplide(this);
                let thumbnailSplide = getThumbnailSplide(thumbnailSelector[0]);
                mainSplide.sync(thumbnailSplide);
                mainSplide.mount();
                thumbnailSplide.mount();
                mainSplide.go(0);
                thumbnailSplide.go(0);
            }
        });
    }
}